import BuyIntentionOffers from 'components/Modals/BuyIntentionOffers';
import ConfirmationModal from 'components/Modals/Confirmation';
import { useTranslation } from 'react-i18next';
import ObservationsOffer from '../../../components/Modals/BuyIntention/ObservationsOffer';
import { BuyIntentionItemActions } from './useBuyIntentionItemActions';
import * as S from './styles';

interface Props {
  actions: BuyIntentionItemActions;
}

export default function BuyIntentionItemModals({ actions }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <ObservationsOffer
        onSubmit={actions.changeOfferInput}
        visible={actions.showObservationModal}
        setVisible={actions.setShowObservationModal}
        valueObs={actions.obsText}
        valueRecord={actions.recordData}
      />

      <ConfirmationModal
        modalIsVisible={actions.showRegisterConfirmationModal}
        actionButtonOk={() => actions.showOffers()}
        actionButtonCancel={() => actions.addIntention()}
        textButtonCancel={t('buyIntention.modals.registerBuyIntention')}
        textButtonOk={t('buyIntention.modals.showOffers')}
        textDescription={t('buyIntention.modals.questionOffers')}
        textTitle={t('buyIntention.modals.offersTitle')}
        widthModal={600}
      />

      <ConfirmationModal
        modalIsVisible={actions.showDeleteModal}
        textTitle=" Excluir"
        textDescription={`Deseja excluir o Produto ${actions.nameProduct}?`}
        textButtonOk="Sim"
        textButtonCancel="Não"
        actionButtonOk={actions.confirmDelete}
        actionButtonCancel={actions.cancelDelete}
      />

      <BuyIntentionOffers
        modalIsVisible={actions.showModalOffers}
        setModalIsVisible={actions.closeOffersModal}
      />
    </>
  );
}

export function BuyIntentionItemsLoading({
  isLoading,
}: {
  isLoading: boolean;
}) {
  if (!isLoading) return null;
  return (
    <S.Overlay>
      <S.Loader spinning={isLoading} size="large" />
    </S.Overlay>
  );
}
